define('viewModels/privileged/composer/forms/QualityFormsList',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'moment',
    'viewModels/ViewModel',
    'models/composer/forms/FormType',
    'services/composer/surveyFormService',
    'services/composer/evaluationFormService',
    'services/qm/qualityAuth',
    'services/navHelper',
    'services/routeService',
    'services/toastService',

    // No reference
    'bindingHandlers/inlineConfirmation',
    'bindingHandlers/dataTable/dataTable'
], function (
    ko,
    _,
    Promise,
    moment,
    ViewModel,
    FormType,
    surveyFormService,
    evaluationFormService,
    qualityAuth,
    navHelper,
    routeService,
    toastService
) {
    'use strict';

    var QualityFormsViewModel = ViewModel.extend(function () {
        var self = this;

        self.nameFilter = ko.observable();
        self.formType = ko.observable();

        self.setFormType = function (formType) {
            self.formType(formType);

            if (self.formType() === FormType.evaluation) {
                self.i18nPrefix = "composer.evaluations.";
                self.pathPrefix = "admin/evaluationForms/";
                self.composerService = evaluationFormService;
                self.canAdd = qualityAuth.canAddEvaluationForm();
                self.canDelete = qualityAuth.canDeleteEvaluationForm();
            } else if (self.formType() === FormType.survey) {
                self.i18nPrefix = "composer.surveys.";
                self.pathPrefix = "admin/surveyForms/";
                self.composerService = surveyFormService;
                self.canAdd = qualityAuth.canAddSurveyForm();
                self.canDelete = qualityAuth.canDeleteSurveyForm();
            }

            self.refreshGrid();
        };

        /**
         * Override
         */
        var columns = [{
                id: 'formName',
                label: self.i18nPrefix + 'list.grid.instanceName'
            },
            {
                id: 'modifiedDateData',
                label: 'composer.evaluations.list.grid.lastModified'
            },
            {
                id: 'published',
                label: 'composer.evaluations.list.grid.published'
            }
        ];

        self.gridOptions = ko.observable({
            pageCount: 1,
            pageNumber: 1,
            pageSize: 25
        });

        self.qualityFormGrid = ko.observable();
        self.loading = ko.observable(false);
        self.isDeleting = ko.observable(false);

        function getOptions(incomingOptions) {
            var options = {
                expand: surveyFormService.EXPAND_PUBLISH_HISTORY_FLAG // "publishHistory" is the same for both services
            };
            if (self.nameFilter()) {
                options.name = self.nameFilter();
            }
            if (incomingOptions) {
                if (incomingOptions.pageSize > self.gridOptions().pageSize) {
                    options.pageNumber = 1;
                } else {
                    options.pageNumber = incomingOptions.pageNumber;
                }
                options.pageSize = incomingOptions.pageSize;
            }
            return options;
        }

        self.refreshGrid = function (incomingOptions) {
            var options = getOptions(incomingOptions);
            return self.composerService.get.page(options)
                .then(function qualityFormsVm_listEntities_getListThen(unpublishedPage) {
                    var unpublished = unpublishedPage.asList();
                    self.gridOptions({
                        pageCount: unpublishedPage.pageCount,
                        pageNumber: unpublishedPage.pageNumber,
                        pageSize: unpublishedPage.pageSize
                    });
                    var rows = _.map(unpublished, function (form) {
                        var topPathname = window.top.location.pathname;
                        var topHash = window.top.location.hash;
                        var formHref = topPathname + topHash + "/" + form.id;
                        var published = _.map(form.publishedVersions, function (pub) {
                            var publishedFormHref = topPathname + topHash + "/" + pub.id;
                            return { //Data for each published form: name, date, link
                                name: pub.name,
                                //Using moment for parsing, see above
                                modifiedDate: moment(pub.modifiedDate).toDate(),
                                disabled: pub.disabled,
                                anchor: {
                                    href: publishedFormHref,
                                    target: "_top"
                                }
                            };
                        });
                        return {
                            id: form.id,
                            anchor: {
                                href: formHref,
                                target: "_top"
                            },
                            formName: {
                                label: form.name(),
                            },
                            modifiedDateData: moment(form.modifiedDate()).toDate(),
                            published: {
                                first: published[0], //convenience accessor for newest published version
                                all: published,
                                total: form.totalPublishedVersions
                            }
                        };
                    });
                    self.qualityFormGrid().rows(rows);
                })
                .finally(function () {
                    self.loading(false);
                });
        };

        self.qualityFormGrid({
            columns: columns,
            rows: ko.observableArray([]),
            selectedRows: ko.observableArray([]),
            dataOptions: self.gridOptions,
            onDataOptionsChange: self.refreshGrid,
            loading: self.loading
        });

        self.areRowsSelected = self.computed(function () {
            return self.qualityFormGrid().selectedRows().length > 0;
        });

        self.rowsDeleted = function (rowCount) {
            var key;
            if (rowCount > 1) {
                key = self.i18nPrefix + 'list.deleteMultipleSuccess.message';
            } else {
                key = self.i18nPrefix + 'list.deleteSuccess.message';
            }

            toastService.notifyMessage(
                'composer.evaluations.list.deleteSuccess.title', {
                    bodyMessageKey: key,
                    icon: "fa-check-circle"
                }
            );
        };

        self.deleteConfirmationMessageKey = ko.observable();
        self.showDeleteConfirmationDialog = ko.observable(false);
        self.openDeleteConfirmation = function () {
            var selectedRows = self.qualityFormGrid().selectedRows();
            if (selectedRows && selectedRows.length > 1) {
                self.deleteConfirmationMessageKey(self.i18nPrefix + 'confirmDeleteMultiple');
            } else {
                self.deleteConfirmationMessageKey(self.i18nPrefix + 'confirmDeleteSingle');
            }
            self.showDeleteConfirmationDialog(true);
        };

        self.deleteSelectedRows = function () {
            self.showDeleteConfirmationDialog(false);
            self.isDeleting(true);
            var selectedRows = self.qualityFormGrid().selectedRows();
            if (selectedRows && selectedRows.length > 0) {
                Promise.all(
                    _.map(selectedRows, function (row) {
                        return self.deleteEntity(row.id);
                    })
                ).catch(function qualityFormsVm_deleteEntity_delInstanceFail(err) {
                    if (err.details.status !== 404) {
                        toastService.notifyMinorAlert(
                            'composer.evaluations.list.deleteFail.title', {
                                bodyMessageKey: self.i18nPrefix + 'list.deleteFail.message'
                            }
                        );
                    }
                }).finally(function () {
                    self.isDeleting(false);
                    self.refreshGrid();
                });
            }
        };


        self.deleteEntity = function (id) {
            return self.composerService.del.instance(id);
        };

        self.clearFields = function () {
            self.nameFilter("");
            self.refreshGrid();
        };

        self.create = function () {
            navHelper.navigateTo(self.pathPrefix + 'new');
        };
    });

    return QualityFormsViewModel;
});

